import React, { useState, useRef } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  TextInput,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { authActionLogin } from "../../action/authAction";
import { useRecoilState } from "recoil";
import { tokenState, userState } from "../../reducer/recoil";
const { width, height } = Dimensions.get("window");
import { styles, stylesResponsive } from "./style";
export default function index({ navigation }) {
  const [remember, setRemember] = useState(false);
  const [token, setToken] = useRecoilState(tokenState);

  const [status, setStatus] = useState();
  const [state, setState] = useState({
    username: "",
    password: "",
    rememberMe: false,
  });
  async function onPress() {
    if (state.username.length > 0 && state.password.length > 0) {
      const login = await authActionLogin(state);
      setToken(login);
      console.log(login);
      if (login) {
        if (login.user !== undefined && login.user.role == "Admin") {
          navigation.navigate("Home");
        }
        if (login.user !== undefined && login.user.role == "User") {
          navigation.navigate("HomeUser");
        }
      }
      if (!login) {
        setStatus(login);
      }
    }
  }
  return (
    <LinearGradient
      start={{ x: 0.0, y: 0.0 }}
      end={{ x: 1.0, y: 1.0 }}
      colors={["#173B64", "#2665AE"]}
      style={styles.container}
    >
      <ScrollView>
        <TouchableOpacity
          onPress={() => {
            navigation.navigate("Entersite");
          }}
          style={styles.buttonEnterSite}
        >
          <Text
            style={
              width <= 500
                ? stylesResponsive.textEnterSite
                : styles.textEnterSite
            }
          >
            {"enter site >>"}
          </Text>
        </TouchableOpacity>

        <View
          style={width <= 500 ? stylesResponsive.viewLogo : styles.viewLogo}
        >
          <Image
            resizeMode={"contain"}
            source={require("../../img/logo4.png")}
            style={width <= 500 ? stylesResponsive.imgLogo : styles.imgLogo}
          />
          <Text
            style={width <= 500 ? stylesResponsive.textTitle : styles.textTitle}
          >
            {"ASIAN ATHLETICS\nASSOCIATION"}
          </Text>
        </View>
        <View
          style={width <= 500 ? stylesResponsive.viewLogin : styles.viewLogin}
        >
          <TextInput
            onChangeText={(text) => setState({ ...state, username: text })}
            onSubmitEditing={() => {
              onPress();
            }}
            defaultValue={state.username}
            placeholder="Username or E-mail"
            style={[
              width <= 500 ? stylesResponsive.InputLogin : styles.InputLogin,
              { borderWidth: status == false ? 1 : 0, borderColor: "red" },
            ]}
          />
          <TextInput
            onChangeText={(text) => setState({ ...state, password: text })}
            onSubmitEditing={() => {
              onPress();
            }}
            defaultValue={state.password}
            secureTextEntry
            placeholder="Password"
            source
            style={[
              width <= 500 ? stylesResponsive.InputLogin : styles.InputLogin,
              { borderWidth: status == false ? 1 : 0, borderColor: "red" },
            ]}
          />
          {status == false && (
            <Text
              style={{
                fontSize: 12,
                fontFamily: "Prompt",
                color: "red",
                marginHorizontal: 45,
              }}
            >
              Please enter a valid email or password.
            </Text>
          )}
          <TouchableOpacity
            onPress={() => {
              setRemember((val) => !val);
            }}
            style={
              width <= 500
                ? stylesResponsive.buttonRemember
                : styles.buttonRemember
            }
          >
            <View
              style={[
                styles.viewRemember,
                { backgroundColor: remember ? "#2B6AB1" : "#FFFFFF" },
              ]}
            />
            <Text
              style={
                width <= 500
                  ? stylesResponsive.textRemember
                  : styles.textRemember
              }
            >
              Remember me
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={onPress}
            style={
              width <= 500 ? stylesResponsive.buttonLogin : styles.buttonLogin
            }
          >
            <Text style={styles.textLogin}>LOGIN</Text>
          </TouchableOpacity>
          <Text
            style={
              width <= 500
                ? stylesResponsive.TextForgotPassword
                : styles.TextForgotPassword
            }
          >
            {"Forgot your password ?\nPlease contact AAA Service"}
          </Text>
        </View>
      </ScrollView>
    </LinearGradient>
  );
}
